export const CyCrewSelector = {
  ButtonSelectCrew: "ButtonSelectCrew",
  LargeSelectors: "LargeSelectors",
} as const;
